import { LazoPaths } from "@/enums/LazoPaths";
import environment from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/environment.json";
import AuthService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/AuthService";
import NotificationService from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/services/NotificationService";
import { AddOnObjectKeyPathMap, AddOnObjectKeyType } from "@/models/subscriptions/AddOn";
import { SubscriptionPurchase } from "@/models/subscriptions/SubscriptionPurchase";
import LazoAuthService from "@/services/LazoAuthService";

export const PostLoginRedirectStorageKey = "postLoginRedirect";
export type AccessMapType = { [k: string]: boolean };

export function generateAccessMap(subscriptionPurchase: SubscriptionPurchase): AccessMapType {
  let addons = [];
  for (const addon of subscriptionPurchase.subscription.addOns) {
    addons.push(addon.objectKey);
  }
  for (const addon of subscriptionPurchase.extraAddOns) {
    addons.push(addon.objectKey);
  }

  const accessMap: AccessMapType = Object.keys(AddOnObjectKeyPathMap).reduce((acc, k) => {
    let found = false;

    if (AddOnObjectKeyPathMap[k].some((a: AddOnObjectKeyType) => addons.includes(a))) {
      found = true;
    }

    acc[k] = found;
    return acc;
  }, {});

  return accessMap;
}

function getRedirectUrl(slug: string) {
  return getHrefBySlug(slug) + LazoPaths.REDIRECT;
}

export function redirectToWorkspace(slug: string, tenantExternalId?: string, currentPathname?: string) {
  const redirectUrl = getRedirectUrl(slug);

  const params = new URLSearchParams();
  if (currentPathname) {
    params.set("p", currentPathname);
  }
  if (tenantExternalId) {
    params.set("tm", tenantExternalId);
  }

  const token = AuthService.getToken();
  const expiresAt = AuthService.getTokenExpiration();

  LazoAuthService.workspaceRedirect(token, expiresAt).then((r) => {
    r.onSuccess((c) => {
      params.set("otc", c.otc);
      window.location.replace(`${redirectUrl}?${params}`);
    }).onError(() => NotificationService.error("There was an error redirecting to workspace"));
  });
}

export function getHrefBySlug(slug: string) {
  const hostArr = window.location.host.split(".");

  if (environment.env === "dev") {
    let localDomain = "";

    if (hostArr.length === 2) {
      localDomain = hostArr[1];
    } else if (hostArr.length === 1) {
      localDomain = hostArr[0];
    } else {
      throw new Error("Error redirecting to workspace, invalid number of domains");
    }

    return `http://${slug}-dev.${localDomain}`;
  }

  // Handle prod and qa subdomain redirection
  let remoteDomain = "";
  const suffix = hostArr[hostArr.length - 1];
  if (hostArr.length === 3 || hostArr.length === 2) {
    remoteDomain = hostArr[1];
  } else {
    throw new Error("Error redirecting to workspace, invalid number of domains");
  }

  const subdomainSuffix = environment.env.toLowerCase() === "qa" ? "-qa" : "";
  return `https://${slug}${subdomainSuffix}.${remoteDomain}.${suffix}`;
}

export const LAZO_SLUGS_BY_ENV = {
  DEV: "lazo",
  QA: "lazo",
  PROD: "lazo_space",
};
